export default "__VITE_ASSET__NvUnzaum__";